import { render, staticRenderFns } from "./addlingInfo.vue?vue&type=template&id=32b48cb4&scoped=true&"
import script from "./addlingInfo.vue?vue&type=script&lang=js&"
export * from "./addlingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b48cb4",
  null
  
)

export default component.exports